import Merchant from '@/models/Merchant';
import CommissionCharge from '@/models/CommissionCharge';

export default {
  merchantDetails: new Merchant(),
  merchantResults: [],
  commissionCharges: new CommissionCharge(),
};
